import CloseIcon from "./index.jsx";

export default CloseIcon;
